import  ReactGA from 'react-ga4'
import { useLocation } from "react-router-dom"
import { useEffect } from 'react'

const GA = ({GA4, UA}) => {
    useEffect(()=>{
        ReactGA.initialize([{trackingId: `${GA4}`}, {trackingId: `${UA}`}]);
    })

    const location = useLocation();

    useEffect(()=>{
        ReactGA.send({
            hitType: "pageview", 
            page: location.pathname + location.search
        })
    },[location])

    return null;
}

export default GA;
